// mutations
const SET_RESULTOWNERSHIP = (state, payload) => {
  state.list_ownership = payload;
};
const SET_INPUTMASTEROWNERSHIP = (state, payload) => {
  state.tempMasterOwnerShip = payload;
};
const SET_IDMASTEROWNERSHIP = (state, payload) => {
  state.idMasterOwnerShip = payload;
};
export default {
  SET_RESULTOWNERSHIP,
  SET_INPUTMASTEROWNERSHIP,
  SET_IDMASTEROWNERSHIP
};
